// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout-module--wrapper--7J2mb","header":"layout-module--header--3DrhJ"};